import { MARK_PATH, MARK_VIEWBOX } from "./logoMark";

export const Logo = ({ variant = "light", size = 40, testId }) => {
  const color = variant === "light" ? "#FFFFFF" : "#16302B";
  return (
    <span
      className="inline-flex items-center select-none font-body"
      style={{ height: size, gap: size * 0.2, color }}
      aria-label="Scale Solutions"
      role="img"
      data-testid={testId}
    >
      <svg viewBox={MARK_VIEWBOX} style={{ height: size * 0.92, width: "auto" }} aria-hidden="true">
        <path fillRule="evenodd" fill="currentColor" d={MARK_PATH} />
      </svg>
      <span className="flex flex-col justify-center" style={{ lineHeight: 0.92 }} aria-hidden="true">
        <span style={{ fontSize: size * 0.44, fontWeight: 300, letterSpacing: "-0.02em" }}>Scale</span>
        <span style={{ fontSize: size * 0.44, fontWeight: 600, letterSpacing: "-0.03em" }}>Solutions</span>
      </span>
    </span>
  );
};
